// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--S8KHW","text":"_2787e5dfdf--text--gBCFi","info-icon":"_2787e5dfdf--info-icon--NgLyv","rate":"_2787e5dfdf--rate--sfubj"};